export enum AuthTokenEnum {
  ACCESS_TOKEN = 'access_token',
  EXPIRES_AT = 'expires_at'
}
